import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  vehicleExplanation: () =>
    i18n.t(i18nKeys.backgroundCheck__vehicleExplanation),
  vehicleTypeLabel: () => i18n.t(i18nKeys.backgroundCheck__vehicleTypeLabel),
  vehicleDetailTitle: () =>
    i18n.t(i18nKeys.backgroundCheck__vehicleDetailTitle),
  required: () => i18n.t(i18nKeys.common__required),
  birthdate: () => i18n.t(i18nKeys.common__birthdate),
  continue: () => i18n.t(i18nKeys.common__continue),
  socialSecurityNumber: () => i18n.t(i18nKeys.common__socialSecurityNumber),
  licenseStateLabel: () => i18n.t(i18nKeys.backgroundCheck__licenseStateLabel),
  licenseStateDisabled: () =>
    i18n.t(i18nKeys.backgroundCheck__licenseStateDisabled),
  licenseNumberLabel: () =>
    i18n.t(i18nKeys.backgroundCheck__licenseNumberLabel),
  insuranceCertificationLabel: () =>
    i18n.t(i18nKeys.backgroundCheck__insuranceCertificationLabel),
  receivesCopy: () => i18n.t(i18nKeys.backgroundCheck__receivesCopy),
  terms: () => i18n.t(i18nKeys.backgroundCheck__terms),
  title: () => i18n.t(i18nKeys.backgroundCheck__title),
  disclosureTitle: () => i18n.t(i18nKeys.backgroundCheck__disclosureTitle),
  backgroundCheckDescription: () =>
    i18n.t(i18nKeys.backgroundCheck__titleDescription),
}
